;(function( window, document, $, undefined ) {
	'use strict';

	// Intro

	function copy() {

    // Copy To Clipboard
    function copyToClipboard( $el ) {
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val($( $el ).text()).select();
      document.execCommand("copy");
      $temp.remove();
    }

		// Globals
		return {
      copyToClipboard: copyToClipboard
		};

	}

	// Globals
	window.app = window.app || {};
  window.app.copy = copy();

})( window, document, jQuery );
